"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useConsolidatedParams;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _invariant = _interopRequireDefault(require("invariant"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useProductPatameters3 = _interopRequireDefault(require("../useProductPatameters"));

var _consolidateParams = _interopRequireDefault(require("./consolidateParams"));

/**
 * Returns merged and normalized `Array` of product root parameters as 'sku', 'ean' ect. and
 * `products.parameters`.
 *
 * @param {Object} options
 * @param {string} [options.parametersField = 'parameters']
 * @param {string} options.translationPrefix
 * @param {Array} options.toTransferCfg
 * @param {Object} product
 *
 * @returns Memoized merged and normalized `Array` of product parameters.
 */
function useConsolidatedParams(options, product) {
  var t = (0, _useTranslate.default)();

  var _useProductPatameters = (0, _useProductPatameters3.default)(),
      _useProductPatameters2 = (0, _slicedToArray2.default)(_useProductPatameters, 1),
      parametersSearchable = _useProductPatameters2[0];

  var _ref = options || {},
      translationPrefix = _ref.translationPrefix;

  (0, _invariant.default)(translationPrefix, 'useConsolidatedParams requires translationPrefix');
  return _react.default.useMemo(function () {
    return (0, _consolidateParams.default)(parametersSearchable, t, options, product);
  }, [options, parametersSearchable, product, t]);
}